import { render, staticRenderFns } from "./Billing-Address.vue?vue&type=template&id=72445b1a"
import script from "./Billing-Address.vue?vue&type=script&lang=js"
export * from "./Billing-Address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports